import React, { useState } from "react";
import "./Grooming.scss";
import HeroImg from "../Components/Layouts/HeroImg";

const Grooming = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  
  const services = [
    {
      id: 1,
      name: "Basic Bath & Brush",
      description: "Includes shampoo, brushing, and blow-dry.",
      duration: "30-45 minutes",
      benefits: ["Cleans fur", "Removes loose hair", "Keeps coat healthy"],
      price: "$25",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 2,
      name: "Full Grooming",
      description: "Complete service including bath, haircut, nail trimming.",
      duration: "1-2 hours",
      benefits: ["Stylish haircut", "Paw and nail care", "Fresh and clean coat"],
      price: "$50",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 3,
      name: "Flea & Tick Treatment",
      description: "Special medicated bath to remove fleas and ticks.",
      duration: "45-60 minutes",
      benefits: ["Eliminates fleas & ticks", "Prevents infestations"],
      price: "$35",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 4,
      name: "Ear Cleaning",
      description: "Gentle ear cleaning to prevent infections and wax buildup.",
      duration: "10-15 minutes",
      benefits: ["Prevents infections", "Removes wax & debris"],
      price: "$15",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 5,
      name: "Nail Clipping",
      description: "Safe and painless nail trimming to keep your pet comfortable.",
      duration: "10-20 minutes",
      benefits: ["Prevents overgrown nails", "Reduces injury risks"],
      price: "$12",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 6,
      name: "Teeth Cleaning",
      description: "Dental care service for fresh breath and healthy gums.",
      duration: "20-30 minutes",
      benefits: ["Prevents bad breath", "Reduces plaque buildup"],
      price: "$30",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 7,
      name: "Paw Pad Treatment",
      description: "Moisturizing treatment for cracked and dry paw pads.",
      duration: "15 minutes",
      benefits: ["Softens paws", "Prevents cracking"],
      price: "$18",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 8,
      name: "De-Shedding Treatment",
      description: "Reduces excessive shedding with special tools and shampoos.",
      duration: "45-60 minutes",
      benefits: ["Minimizes shedding", "Healthier coat"],
      price: "$40",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 9,
      name: "Skunk Odor Removal",
      description: "Special treatment to eliminate skunk odor from your pet's fur.",
      duration: "45 minutes",
      benefits: ["Removes strong odors", "Leaves a fresh scent"],
      price: "$45",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 10,
      name: "DermaSoothe Therapy",
      description: "Hypoallergenic shampoo for pets with sensitive skin.",
      duration: "30 minutes",
      benefits: ["Soothes skin", "Reduces irritation"],
      price: "$38",
      imgSrc: "/groomimg.jpg",
    },
    {
      id: 11,
      name: "Luxury Spa Package",
      description: "A full pampering session with bath, massage, and grooming.",
      duration: "2-3 hours",
      benefits: ["Total relaxation", "Full grooming service"],
      price: "$80",
      imgSrc: "/groomimg.jpg",
    },
  ];
  
  
  return (
    <>
      <HeroImg heading="Grooming Services" text="Our Services/Grooming"/>
      <div className="grooming-grid">
        {services.map((service) => (
          <div key={service.id} className="grooming-card">
            <img src={service.imgSrc} alt={service.name} />
            <h2>{service.name}</h2>
            <p>{service.description}</p>
            <p className="price">{service.price}</p>
            <button 
                onClick={() => {
                setSelectedService(service);
                setIsModalOpen(true);
              }} 
                className="view-details">
                  View Details
            </button>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="modal-overlay active" onClick={()=>setIsModalOpen(false)}>
          <div className="modal active" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <span
                className="close-modal"
                onClick={() => {
                  setSelectedService(null);
                  setIsModalOpen(false);
                }}
              >
                &times;
              </span>
              <img src={selectedService.imgSrc} alt={selectedService.name} />
              <h2>{selectedService.name}</h2>
              <p>
                <strong>Description:</strong> {selectedService.description}
              </p>
              <p>
                <strong>Duration:</strong> {selectedService.duration}
              </p>
              <ul>
                <strong>Benefits:</strong>
                {selectedService.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
              <p className="price">{selectedService.price}</p>
              <button className="book-now" onClick={() => alert("Booking confirmed!")}>Book Now</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Grooming;
